import CheckBoxList from './checkbox-list.vue'
export default CheckBoxList



// WEBPACK FOOTER //
// ./src/components/checkbox-list/index.js